import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [devLink, setDevLink] = useState("");
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setDone(true);
            if (data.dev_reset_link) setDevLink(data.dev_reset_link);
        } catch (e) {
            setErr(formatApiError(e.response?.data?.detail) || e.message);
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg)]" data-testid="forgot-password-page">
            <div className="w-full max-w-md">
                <Logo size="sm" />
                <p className="label-tiny mt-10 mb-3">/ Recover access</p>
                <h2 className="font-serif text-5xl mb-2">Forgot password</h2>
                <p className="text-[var(--text-muted)] text-sm mb-10">We'll send you a secure reset link.</p>

                {!done ? (
                    <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
                        <div>
                            <label className="label-tiny block mb-2">Email</label>
                            <input data-testid="forgot-email" type="email" className="input-dark" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                        {err && <div className="text-sm text-[var(--danger)]">{err}</div>}
                        <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="forgot-submit">
                            {busy ? "Sending…" : "Send reset link →"}
                        </button>
                    </form>
                ) : (
                    <div className="border border-[var(--gold-deep)] bg-[var(--surface)] p-5 space-y-3" data-testid="forgot-success">
                        <p className="text-[var(--gold-bright)] font-medium">Check your inbox.</p>
                        <p className="text-sm text-[var(--text-muted)]">If <span className="font-mono">{email}</span> is registered, we just sent a reset link valid for 1 hour.</p>
                        {devLink && (
                            <div className="border-t border-[var(--border)] pt-3">
                                <p className="label-tiny mb-2">Dev mode (no email service yet)</p>
                                <Link to={devLink.split("?")[1] ? `/reset-password?${devLink.split("?")[1]}` : "/login"} className="text-xs font-mono text-[var(--gold)] break-all hover:text-[var(--gold-bright)]" data-testid="dev-reset-link">
                                    Click here to reset →
                                </Link>
                            </div>
                        )}
                    </div>
                )}

                <div className="gold-rule my-10" />
                <Link to="/login" className="text-sm text-[var(--text-muted)] hover:text-[var(--gold)]" data-testid="back-to-login">
                    ← Back to sign in
                </Link>
            </div>
        </div>
    );
}
